// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__bbI_0","tab":"Tabs_tab__3a_s3","tabActive":"Tabs_tabActive__231dz"};